import { render, staticRenderFns } from "./VisitRequests.vue?vue&type=template&id=30cfc4a6&"
import script from "./VisitRequests.vue?vue&type=script&lang=js&"
export * from "./VisitRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports